import { AppTooltip } from '@components/ui/tooltip/tooltip';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

type CrewAvatarProps = React.HTMLAttributes<HTMLSpanElement> & {
  defaultChildren?: ReactNode;
  hideTooltip?: boolean;
  children?: ReactNode;
};

export const CrewAvatar = ({
  defaultChildren,
  className = '',
  hideTooltip = false,
  children,
  ...props
}: CrewAvatarProps) => {
  const { t } = useTranslation('app');

  if (!hideTooltip) {
    return (
      <AppTooltip context={<span>{t('pages.users.removed')}</span>}>
        <span
          className={`flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-blue-400 font-inter text-white ${
            className || 'h-7 w-7'
          }`}
          {...props}></span>
      </AppTooltip>
    );
  }

  return (
    <span
      className={`flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-blue-400 font-inter text-white ${
        className || 'h-7 w-7'
      }`}
      {...props}>
      {defaultChildren || children}
    </span>
  );
};
